// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__3nAVs","skeleton_user":"Skeleton_skeleton_user__3Le5j","img":"Skeleton_img__3CL1_","content":"Skeleton_content__YY37O","row":"Skeleton_row__132px"};